<template>
	<section class="fac-card-accordion" :class="design">
        <!-- @slot Utilize para inserir os ítems -->
        <slot></slot>
	</section>
</template>
<script>
	export default {
        name: 'ui-card-accordion-body',
        props: {
            /**
             * Utilize para aplicar as classes css
             */
			design: {
				type: String,
				required: false,
			}, 
		},
        data() {
            return {
                nextID: 0,
            }
        },
		methods: {
			generateID() {
                const id = this.nextID.toString(10);
                this.nextID += 1;
                return id;
            },
		},
		mounted(){
            this.$on("register-card", (card) => {
                const id = this.generateID();
                card.setID(id)
            })
            this.$on("request-open", (card) => {
                this.$emit("toggle", card.id);
            });
		}
    };
</script>

<style lang="stylus" scoped>
    @import '../styles.styl';
</style>

